import { Link } from "@tanstack/react-router";

export default function Support() {
  return (
    <div className="min-h-screen bg-background">
      <div className="h-screen max-h-screen overflow-y-auto">
        <div className="px-5 pt-4 pb-9 max-w-[50rem] mx-auto flex flex-col gap-6">
          <h1 className="text-3xl font-black text-text tracking-tight">Support</h1>

          <p className="text-text-muted text-base leading-6">
            Need help with FootSlapping? We are here for you.
          </p>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">Contact Us</h2>
            <p className="text-text-muted text-sm leading-6">
              Email us at{" "}
              <a
                href="mailto:support@footslapping.com"
                className="text-aqua underline underline-offset-2"
              >
                support@footslapping.com
              </a>{" "}
              and we will get back to you as soon as we can.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">Frequently Asked Questions</h2>
            <p className="text-text-muted text-sm leading-6">
              Before reaching out, check our{" "}
              <Link to="/faq" className="text-aqua underline underline-offset-2">
                FAQ page
              </Link>{" "}
              for answers to common questions about step syncing, troubleshooting, and more.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
